export const executeAndSetInterval = (action: () => void, interval: number) => {
  action()
  return setInterval(action, interval)
}
